<template>
    <van-form ref="form" v-model="form">
        <van-field
            label="开始时间"
            is-link
            readonly
            v-model="form.workstart"
            :show-error="true"
            :show-error-message="false"
            name="workstart"
            :rules="[{ required: true,message:'请填写工作开始的时间',trigger:'on'}]"
            @click="showWorkStart = true"
        />
        <van-popup v-model:show="showWorkStart" position="bottom">
            <van-datetime-picker 
            type="year-month"
            :minDate="new Date(2000,1,1)"
            :maxDate="new Date()"
            @confirm="onWorkStartConfirm"
            @cancel="showWorkStart = false"
            >
            </van-datetime-picker>
        </van-popup>
        <van-field
            label="结束时间"
            is-link
            readonly
            v-model="form.workend"
            name="workend"
            @click="showWorkEnd = true"
            :rules="[{ required: true,message:'请填写工作结束的时间'}]"
        />
        <van-popup v-model:show="showWorkEnd" position="bottom">
            <van-datetime-picker 
            type="year-month"
            :minDate="new Date(2000,1,1)"
            :maxDate="new Date()"
            @confirm="onWorkEndConfirm"
            @cancel="showWorkEnd = false"
            >
            </van-datetime-picker>
        </van-popup>
        <van-field label="公司单位" v-model="form.unit" name="unit" :rules="[{ required: true,message:'请填写公司单位'}]"/>
        <van-field label="岗位" v-model="form.work" name="work" :rules="[{ required: true,message:'请填写担任岗位'}]"/>
        <van-field label="薪资" v-model="form.salary" name="salary" type="number" :rules="[{ required: true,message:'请填写待遇薪资'}]"/>
        <van-field
            label="离职原因"
            v-model="form.leave"
            name="leave"
            rows="2"
            type="textarea"
            :rules="[{ required: true,message:'请填写离职的原因'}]"
        />
    </van-form>
</template>
<script>
import { monthFormat } from '@/comm/comm.js'
export default {
    name:'addMyWorkHis',
    data(){
        return{
            showWorkStart:false,
            showWorkEnd:false,
            form:{
                workstart: "",
                workend:'',
                unit:'',
                salary:'',
                leave:'',
                work:'',
                guid:''
            }
        }
    },
    methods:{
        onWorkStartConfirm(res){
            this.showWorkStart = false
            this.form.workstart = monthFormat(res)           
        },
        onWorkEndConfirm(res){
            this.showWorkEnd = false
            this.form.workend = monthFormat(res)           
        },
        onReset(){
            this.$refs.form.resetValidation()
        },
        validateForm() {
            return this.$refs.form.validate()
        },
    }
}
</script>